
import * as React from 'react';
import { ListItem, StyledComponentProps, Divider, Grid, Typography } from '@material-ui/core';
import { contactSubscription } from '../../../../model/contactsubscription';
import moment from 'moment';
import { SUBSCRIPTIONTYPES } from '../../../../model/subscription';

interface IProps extends StyledComponentProps {
    // doneReminder: (reminder: reminder, done: boolean) => void;
    // onSubscriptionClick: (_id: string) => void;
    subscription: contactSubscription;
    onSelectItem: (item: any) => void;
    // isSelected: boolean;
    // showContactInfo?: boolean;
    // navigateTo: (path: string) => void;
}
export const isExpired = (expireDate: Date): boolean => {
    // var d = (new Date())
    // console.info("isExpired DATE  : ", moment(expireDate).toDate(), d, "COMPARE:", (moment(expireDate).toDate() > (new Date())))
    // console.info("isExpired NEAR +15day : ", moment(expireDate).add(15, 'd').toDate(), "COMPARE:", (moment(expireDate).add(15, 'd').toDate() > (new Date())))
    // return (moment(expireDate).toDate() <= (new Date()));
    return (moment(expireDate).toDate() < (new Date()));
}
export const isNearExpiration = (expireDate: Date): boolean => {
    // console.info("isNearExpiration DATE -15day : ", moment(expireDate).add(15, 'd').toDate())
    return (moment(expireDate).subtract(15, 'd').toDate() < (new Date()));
}

export const SubscriptionItem = (props: IProps) => {
    const subscriptionText = (subscription: contactSubscription) => {
        if (subscription.subscription?.subscriptionType === SUBSCRIPTIONTYPES.ACCESSI.code && subscription.notes && subscription.notes !== "")
            return <>
                {subscription.subscription?.subscriptionName}<br />{subscription.subscription?.accessToBuy + " ACCESSI ACQUISTATI"}
                {subscription.accessesExtra && subscription.accessesExtra > 0 ? " + " + subscription.accessesExtra + " EXTRA " : ""}
                {(subscription.registeredAccess && subscription.registeredAccess > 0 ? " " + subscription.registeredAccess : " 0") + " CONSUMATI"}
                <br />{subscription.notes}</>
        else if (subscription.subscription?.subscriptionType === SUBSCRIPTIONTYPES.ACCESSI.code)
            return <>{subscription.subscription?.subscriptionName}<br />{subscription.subscription?.accessToBuy + " ACCESSI ACQUISTATI"
                + (subscription.accessesExtra > 0 ? " + " + subscription.accessesExtra + " EXTRA " : "")
                + " - " + subscription.registeredAccess + " CONSUMATI"}</>
        else if (subscription.notes && subscription.notes !== "")
            return <>{subscription.subscription?.subscriptionName}<br />{subscription.notes}</>
        return <>{subscription.subscription?.subscriptionName}</>
    }
    const { subscription, classes, onSelectItem } = props;
    return (
        <>
            <ListItem key={subscription._id}
                onClick={() => onSelectItem(subscription)}
                className={isExpired(subscription.expiresOn) ? classes.isExpired : (isNearExpiration(subscription.expiresOn) ? classes.isNearExpiration : classes.isValid)}>
                <Grid container>
                    <Grid item xs={8}>
                        <Typography className={classes.typoPurchased}>
                            {subscriptionText(subscription)}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography className={classes.typoPurchased}>
                            {'Valido dal: ' + moment(subscription.validFrom).format('L')}</Typography>
                        <Typography className={classes.typoPurchased}>
                            {'Scade il: ' + moment(subscription.expiresOn).add(subscription.daysExtra, 'd').format('L')}</Typography>
                        {/* <Typography className={classes.typoPurchased}>
                            {'Scade tra 5 giorni'}</Typography> */}
                    </Grid>
                </Grid>
            </ListItem>
            <Divider />
        </>
    );
}